import type { BankAccount } from '@/types/external/2work/api/request/BankAccount'

interface BankPayloadSource {
  is_default?: 0 | 1 | undefined
  organization_name?: null | string | undefined
  tw_bank?: null | string | undefined
  tw_bank_account_bic?: null | string | undefined
  tw_bank_account_iban?: null | string | undefined
  tw_bank_account_owner?: null | string | undefined
}

interface BankFormValues {
  is_default?: 0 | 1
  tw_bank?: string
  tw_bank_account_bic?: string
  tw_bank_account_iban?: string
  tw_bank_account_owner?: string
}

const buildBankAccountPayload = (
  formValues: BankPayloadSource,
  partyName?: null | string,
  partyType?: null | string,
  isCompanyAccount: 0 | 1 = 1,
): BankAccount => {
  const payload: BankAccount = {
    is_company_account: isCompanyAccount,
    is_default: formValues.is_default ?? 0,
  }

  if (partyName) {
    payload.party = partyName
  }

  if (partyType) {
    payload.party_type = partyType
  }
  if (formValues.tw_bank) {
    payload.bank = formValues.tw_bank
  }

  const owner = formValues.tw_bank_account_owner ?? undefined
  const orgName = formValues.organization_name ?? undefined
  const accountName = owner ?? orgName
  if (accountName !== undefined) {
    payload.account_name = accountName
  }

  if (formValues.tw_bank_account_bic) {
    payload.branch_code = formValues.tw_bank_account_bic
  }
  if (formValues.tw_bank_account_iban) {
    // Send IBAN exactly as typed; backend handles validation and formatting rules.
    payload.iban = formValues.tw_bank_account_iban
  }

  return payload
}

const toBankFormValuesFromOrg = (
  org?: null | {
    tw_bank?: null | string
    tw_bank_account_bic?: null | string
    tw_bank_account_iban?: null | string
    tw_bank_account_owner?: null | string
  },
): BankFormValues => {
  return {
    tw_bank: org?.tw_bank ?? '',
    tw_bank_account_bic: org?.tw_bank_account_bic ?? '',
    tw_bank_account_iban: org?.tw_bank_account_iban ?? '',
    tw_bank_account_owner: org?.tw_bank_account_owner ?? '',
  }
}

const toBankFormValuesFromAccount = (
  account?: null | {
    account_name?: null | string
    bank?: null | string
    branch_code?: null | string
    iban?: null | string
    is_default?: 0 | 1
  },
): BankFormValues => {
  return {
    is_default: account?.is_default ?? 0,
    tw_bank: account?.bank ?? '',
    tw_bank_account_bic: account?.branch_code ?? '',
    tw_bank_account_iban: account?.iban ?? '',
    tw_bank_account_owner: account?.account_name ?? '',
  }
}

export type { BankFormValues, BankPayloadSource }
export { buildBankAccountPayload, toBankFormValuesFromAccount, toBankFormValuesFromOrg }
